// plugins/1.authService.ts
import { createAuthService } from '@/services/auth/authService'
import { initializeFirebase, getFirebaseAuth, getFirebaseDb } from '@/services/firebaseService'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  // Firebase 초기화
  initializeFirebase({
    apiKey: config.public.FIREBASE_API_KEY as string,
    authDomain: config.public.FIREBASE_AUTH_DOMAIN as string,
    projectId: config.public.FIREBASE_PROJECT_ID as string,
    appId: config.public.FIREBASE_APP_ID as string,
  })

  return {
    provide: {
      authService: createAuthService(),
      firebaseAuth: getFirebaseAuth(),
      firebaseDb: getFirebaseDb(),
    },
  }
})
